var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useIntl } from 'react-intl';
import { Accordion, AccordionSet, Layout, Loading } from '@folio/stripes/components';
import { TitleManager } from '@folio/stripes/core';
import { useHistory, useParams } from 'react-router-dom';
import { useCreateList, useInitRefresh, useListDetails, useMessages, useRecordTypeLabel } from '../../hooks';
import { computeErrorMessage, t } from '../../services';
import { EditListLayout, EditListResultViewer, ErrorComponent, MainListInfoForm } from '../../components';
import { useCopyListFormState } from './hooks';
import { FIELD_NAMES, STATUS_VALUES } from '../../interfaces';
import { HOME_PAGE_URL } from '../../constants';
export var CopyListPage = function () {
    var _a, _b, _c, _d, _e, _f;
    var history = useHistory();
    var intl = useIntl();
    var id = useParams().id;
    var _g = useListDetails(id), listDetails = _g.data, loadingListDetails = _g.isLoading, detailsError = _g.detailsError;
    var recordTypeLabel = useRecordTypeLabel(listDetails === null || listDetails === void 0 ? void 0 : listDetails.entityTypeId);
    var listName = (_a = listDetails === null || listDetails === void 0 ? void 0 : listDetails.name) !== null && _a !== void 0 ? _a : '';
    var fqlQuery = (_b = listDetails === null || listDetails === void 0 ? void 0 : listDetails.fqlQuery) !== null && _b !== void 0 ? _b : '';
    var redirectToNewList = function (newListId) {
        history.push("".concat(HOME_PAGE_URL, "/list/").concat(newListId));
    };
    var backToList = function () {
        history.push("".concat(HOME_PAGE_URL, "/list/").concat(id));
    };
    var initRefresh = useInitRefresh({ onSuccess: function (data) {
            redirectToNewList(data.listId);
        } }).initRefresh;
    var _h = useMessages(), showSuccessMessage = _h.showSuccessMessage, showErrorMessage = _h.showErrorMessage;
    var _j = useCopyListFormState(listDetails, loadingListDetails), state = _j.state, onValueChange = _j.onValueChange;
    var recordType = listDetails === null || listDetails === void 0 ? void 0 : listDetails.entityTypeId;
    var _k = useCreateList({
        listObject: __assign(__assign({}, state), { fields: listDetails === null || listDetails === void 0 ? void 0 : listDetails.fields, fqlQuery: fqlQuery, recordType: recordType }),
        onSuccess: function (list) {
            showSuccessMessage({ message: t('callout.list.save.success', {
                    listName: state[FIELD_NAMES.LIST_NAME]
                }) });
            if (state[FIELD_NAMES.STATUS] === STATUS_VALUES.INACTIVE || !fqlQuery) {
                redirectToNewList(list.id);
            }
            initRefresh(list.id);
        },
        onError: function (error) {
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var errorMessage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, computeErrorMessage(error, 'callout.list.save.error', {
                                listName: state[FIELD_NAMES.LIST_NAME]
                            })];
                        case 1:
                            errorMessage = _a.sent();
                            showErrorMessage({ message: errorMessage });
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
    }), saveList = _k.saveList, isLoading = _k.isLoading;
    if (detailsError) {
        return React.createElement(ErrorComponent, { error: detailsError });
    }
    var closeHandler = function () {
        backToList();
    };
    var onSave = function () {
        saveList();
    };
    var hasName = !state[FIELD_NAMES.LIST_NAME];
    if (loadingListDetails) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(TitleManager, { record: intl.formatMessage({ id: 'ui-lists.title.duplicateList' }, { listName: listName }) },
        React.createElement(EditListLayout, { name: listName, onSave: onSave, onCancel: closeHandler, title: t('lists.copy.title', { listName: listName }), isLoading: loadingListDetails, isSaveButtonDisabled: hasName || isLoading },
            React.createElement(AccordionSet, null,
                React.createElement(Accordion, { "data-testid": "metaSectionAccordion", label: t('accordion.title.list-information') },
                    React.createElement(Layout, null,
                        React.createElement(MainListInfoForm, { onValueChange: onValueChange, status: state[FIELD_NAMES.STATUS], listName: state[FIELD_NAMES.LIST_NAME], visibility: state[FIELD_NAMES.VISIBILITY], description: state[FIELD_NAMES.DESCRIPTION], recordTypeLabel: recordTypeLabel, isLoading: loadingListDetails })))),
            React.createElement(EditListResultViewer, { isDuplicating: true, id: id, version: listDetails === null || listDetails === void 0 ? void 0 : listDetails.version, fields: listDetails === null || listDetails === void 0 ? void 0 : listDetails.fields, fqlQuery: (_c = listDetails === null || listDetails === void 0 ? void 0 : listDetails.fqlQuery) !== null && _c !== void 0 ? _c : '', userFriendlyQuery: (_d = listDetails === null || listDetails === void 0 ? void 0 : listDetails.userFriendlyQuery) !== null && _d !== void 0 ? _d : '', contentVersion: (_f = (_e = listDetails === null || listDetails === void 0 ? void 0 : listDetails.successRefresh) === null || _e === void 0 ? void 0 : _e.contentVersion) !== null && _f !== void 0 ? _f : 0, entityTypeId: listDetails === null || listDetails === void 0 ? void 0 : listDetails.entityTypeId, status: state[FIELD_NAMES.STATUS], listName: state[FIELD_NAMES.LIST_NAME], visibility: state[FIELD_NAMES.VISIBILITY], description: state[FIELD_NAMES.DESCRIPTION], isQueryButtonDisabled: hasName || isLoading }))));
};
